module.exports = __webpack_public_path__ + "static/media/default.75345ef6.png";